import React from 'react'
import { Flex, Card, Text, Link as ThemeLink } from 'theme-ui'

export default function Contacts() {
  return (
    <Flex sx={{ gap: 2, flexDirection: 'column' }}>
      <Card p={2}>
        <Text sx={{ display: 'block', fontWeight: 'bold' }}>
          Layanan Pesan Singkat/SMS
        </Text>
        <Text sx={{ display: 'block' }}>+62 853-19000-150</Text>
        <Text sx={{ display: 'block' }}>+62 853-19000-253</Text>
      </Card>
      <Card p={2}>
        <Text sx={{ display: 'block', fontWeight: 'bold' }}>
          Surat Elektronik(e-mail)
        </Text>
        <ThemeLink
          href="mailto:wbs@whistleblowing.link"
          sx={{ display: 'block', fontSize: 0 }}
        >
          wbs@whistleblowing.link
        </ThemeLink>
      </Card>
      <Card p={2}>
        <Text sx={{ display: 'block', fontWeight: 'bold' }}>Telepon</Text>
        <Text sx={{ display: 'block' }}>+62 853-19000-150</Text>
        <Text sx={{ display: 'block' }}>+62 853-19000-253</Text>
      </Card>
      <Card p={2}>
        <Text sx={{ display: 'block', fontWeight: 'bold' }}>Surat</Text>
        <Text sx={{ display: 'block' }}>WBS PO Box 1074 JKS 12010</Text>
      </Card>
      <Card p={2}>
        <Text sx={{ display: 'block', fontWeight: 'bold' }}>
          Kotak Pengaduan
        </Text>
      </Card>
    </Flex>
  )
}
